import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

/**
 * Returns a callback that signs the user out and returns them to postLogoutRedirectUri.
 * Passing the account explicitly clears that account's cached tokens rather than relying
 * on whichever one MSAL considers active.
 */
export function useSignOut(): () => void {
  const { instance } = useMsal();

  return useCallback(() => {
    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
    void instance.logoutRedirect({ account });
  }, [instance]);
}
